import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'webhook-trigger',
  name: 'Webhook',
  category: 'triggers',
  description: 'Receive data from external services via webhook URLs and trigger workflows',
  icon: 'Webhook',
  color: 'blue',
  version: '2.0.0',
  
  group: ['trigger'],
  
  defaults: {
    name: 'Webhook',
    color: '#3b82f6'
  },
  
  subtitle: '={{ $parameter.httpMethod }} {{ $parameter.path }}',
  
  credentials: [
    {
      name: 'httpBasicAuth',
      required: false,
      displayName: 'Basic Auth',
      displayOptions: {
        show: {
          authentication: ['basicAuth']
        }
      }
    },
    {
      name: 'httpHeaderAuth',
      required: false,
      displayName: 'Header Auth',
      displayOptions: {
        show: {
          authentication: ['headerAuth']
        }
      }
    }
  ],
  
  inputs: [],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main'
    }
  ],
  
  tags: ['webhook', 'trigger', 'http', 'api', 'endpoint'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'https://docs.n8n.io/integrations/builtin/core-nodes/n8n-nodes-base.webhook/'
  }
};

export default definition;
